import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonRow,
  IonText,
  IonToast,
} from "@ionic/react";
import { useState } from "react";
import { makePOSTRequest } from "../../request/rawRequest";
import "../IonColor/color.css";
import "../generalCSS/stylesheet.css";
import "./Login.css";
import LogoLogin from "./LogoLogin";
import LogoQualiopi from "./LogoQualiopi";

interface ContainerProps {
  pathLogo: string;
}

const Login: React.FC<ContainerProps> = ({ pathLogo }) => {
  const [showVideo, setShowVideo] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [showToast, setShowToast] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const signIn = async () => {
    await makePOSTRequest("/login", { email: email, password: password })
      .then(async (response) => {
        localStorage.setItem("authToken", response.authToken);

        window.location.reload();
      })
      .catch((error) => {
        setMessage(error.response.data.error);
        setShowToast(true);
      });
  };

  return (
    <IonPage>
      {/* Displaying error on login */}
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={message}
        position="middle"
        color="danger"
        duration={2000}
      />

      {/* End of dislplaying error on login */}
      {showVideo && (
        <div
          style={{
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              backgroundColor: "white",
              height: "100vh",
              width: "100vw",
              zIndex: "99999",
              color: "red",
            }}
          >
            <IonGrid
              className="ion-no-padding"
              style={{
                position: "absolute",
                width: "100%",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <IonRow className="ion-no-padding ion-justify-content-center">
                <IonCol
                  style={{}}
                  className={"ion-no-padding"}
                  size="12"
                  sizeMd="3"
                  sizeSm="12"
                >
                  {/*  <video
                    onEnded={() => {
                      setShowVideo(false);
                    }}
                    style={{
                      width: "100%",
                    }}
                    src="https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/divers/Logo+pour+app(1).mp4"
                    autoPlay
                    muted
                  ></video> */}
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
        </div>
      )}
      {/* Display LOGIN */}
      <IonContent color="primary" className="">
        <IonGrid>
          <LogoLogin path={pathLogo} />
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <form>
                <IonRow className="ion-justify-content-center">
                  <IonText color="black" className="ion-text-center">
                    <h1>Connexion</h1>
                    <h5>Veuillez entrer vos informations</h5>
                  </IonText>
                </IonRow>
                <IonRow class="ion-justify-content-center">
                  <IonCol size="12" size-sm="12" size-lg="8">
                    <IonItem color="transparent">
                      <IonLabel color="black" position="floating">
                        Email
                      </IonLabel>
                      <IonInput
                        name="email"
                        type="email"
                        value={email}
                        onIonChange={(e) => setEmail(e.detail.value!)}
                        required
                      ></IonInput>
                    </IonItem>
                  </IonCol>
                </IonRow>
                <IonRow class="ion-justify-content-center">
                  <IonCol size="12" size-sm="12" size-lg="8">
                    <IonItem color="transparent">
                      <IonLabel color="black" position="floating">
                        Mot De Passe
                      </IonLabel>
                      <IonInput
                        name="password"
                        type="password"
                        value={password}
                        onIonChange={(e) => setPassword(e.detail.value!)}
                        required
                      ></IonInput>
                    </IonItem>
                  </IonCol>
                </IonRow>
              </form>

              <IonRow
                className="ion-justify-content-center"
                style={{
                  alignItems: "stretch",
                }}
              >
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonButton
                    color="secondary"
                    shape="round"
                    expand="full"
                    onClick={(e) => signIn()}
                  >
                    Se Connecter
                  </IonButton>
                </IonCol>

                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonButton
                    color="tertiary"
                    shape="round"
                    expand="full"
                    onClick={() =>
                      (window.location.href =
                        "techno/login?" +
                        (new URLSearchParams(window.location.search).get(
                          "premium"
                        ) !== null
                          ? "premium=true"
                          : ""))
                    }
                  >
                    Pas encore de compte ?
                  </IonButton>
                </IonCol>
              </IonRow>
              <IonRow className="ion-justify-content-center">
                <IonItem color="transparent">
                  <IonText
                    color="black"
                    onClick={() => (window.location.href = "/forgotPassword")}
                  >
                    <h6 className="italic thin hover-underline default-cursor">
                      Mot de passe oublié ?
                    </h6>
                  </IonText>
                </IonItem>
              </IonRow>
            </IonCol>
          </IonRow>
          <LogoQualiopi />
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Login;
